import { Component, effect, ElementRef, OnInit, ViewChild, WritableSignal } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Subscription } from 'src/app/shared/models/model/concretes/shared/subcription.model';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  standalone: true,
  imports: [CommonModule, BreadcrumbModule, RouterModule]
})
export class BreadcrumbComponent implements OnInit {
  items: MenuItem[] = [];

  @ViewChild('scrollContainer') scrollContainer!: ElementRef;

  subscription: WritableSignal<Subscription | null>;

  constructor(private sharedDataService: SharedDataService) {
    this.subscription = this.sharedDataService.getSubscription();

    effect(() => {
      const subSignal = this.sharedDataService.getSubscription();
      if (subSignal != null) {
        this.updateBreadcrumb(subSignal());
        if (document.getElementById('scroll-container')) this.scrollToRight();
      }
    });
  }

  ngOnInit() {
    this.scrollToRight();
  }

  private updateBreadcrumb(subscription: Subscription | null) {
    this.items = [];
    subscription?.groupSteps.map(groupStep => {
      groupStep.steps.map(step => {
        if (step.layoutInfo.breadcrumb != '' && (step.isActive || step.isCompleted))
          this.items?.push({
            label: step.layoutInfo.breadcrumb,
            route: '/subscription/' + step.url,
            visible: step.isCompleted
          });
      });
    });
  }

  private scrollToRight() {
    const container = document.getElementById('scroll-container');

    if (container) {
      container.scrollTo({
        left: container.scrollWidth,
        behavior: 'smooth'
      });
    }
  }
}
